export default (store, roles) => {
  if (!store.getters.getUserRoles) return false
  return store.getters.getUserRoles.some((self) =>
    roles.find((role) => role === self)
  )
}
